/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

// Splash Screen
const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000, // Set animation duration as per your animation
  name: "MOHIT MUROTIYA",
};

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Mohit Murotiya",
  title: "Hi all, I'm MOHIT",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of designing and building Web applications with ReactJS / VueJS / Spring Boot and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1slGuwzx3MAZxaGta9O6qVCiqIynTCALk/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/MohitMurotiya",
  linkedin: "https://www.linkedin.com/in/mohitmurotiya",
  gmail: "mohitmurotiya98@gmail.com",
  gitlab: "https://gitlab.com/mohitmurotiya",
  // facebook: "https://www.facebook.com/mohit.murotiya",
  // medium: "https://medium.com/",
  //stackoverflow: "https://stackoverflow.com/users/13263979/drakosi",
  instagram: 'https://www.instagram.com/mohit.murotiya',
  //twitter: 'https://twitter.com/davidrakosi_',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Tech I'm Familiar with",
  //subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji("⚡ Wants to explore all Tech stacks"),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "vuejs",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "spring",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "mongodb",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "elasticsearch",
      fontAwesomeClassname: "fab fa-searchengin"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "material-ui",
      fontAwesomeClassname: "fab fa-mdb"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "bitbucket",
      fontAwesomeClassname: "fab fa-bitbucket"
    },
    {
      skillName: "jenkins",
      fontAwesomeClassname: "fab fa-jenkins"
    }
    // {
    //   skillName: "firebase",
    //   fontAwesomeClassname: "fas fa-fire"
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Savitribai Phule Pune University",
      logo: require("./assets/images/sppu.jpg"),
      subHeader: "Bachelor of Engineering in Computer Science",
      duration: "July 2016 - Oct 2020",
      desc: "CGPA 8.09",
      descBullets: []
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend / Design", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Database",
      progressPercentage: "60%"
    },
    // {
    //   Stack: "Programming",
    //   progressPercentage: "80%"
    // }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full Stack Developer",
      company: "BARCLAYS",
      companylogo: require("./assets/images/Barclays.png"),
      date: "September 2022 – Present",
      desc: "Cards Platform - US Consumer Banking",
      descBullets: [
        "Presently working as a Full Stack Developer for New Acquisitions Marketing(NAM) Tech team.",
      ]
    },
    {
      role: "Software Engineer",
      company: "CAPGEMINI",
      companylogo: require("./assets/images/cgLogo.png"),
      date: "September 2020 – August 2022",
      desc: "Worked as a Full-Stack Developer",
      descBullets: [
        "Experienced in developing Java based web applications.",
      ]
    },
    {
      role: "Software Developer Intern",
      company: "CAPGEMINI",
      companylogo: require("./assets/images/cgLogo.png"),
      date: "Jan 2020 – May 2020",
      desc: "Completed internship in J2EE form",
      descBullets: [
        "Trained in Angular, Spring MVC, SPring Boot, JPA, MySQL.",
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "MohitMurotiya", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/2048.png"),
      projectName: "2048 GAME",
      projectDesc: "An implementation of the 2048 game using React.",
      footerLink: [
        {
          name: "Play",
          url: "https://clone-2048.netlify.app/"
        },
        {
          name: "Github",
          url: "https://github.com/MohitMurotiya/2048"
        }
      ]
    },
    {
      image: require("./assets/images/wype.png"),
      projectName: "Car Service Application",
      projectDesc: "Full Stack project using MERN Stack. Developed REST APIs in Node JS using Express Framework to be consumed by application. Implemented JWT web token for authentication and authorization.",
      footerLink: [
        {
          name: "YouTube",
          url: "https://youtu.be/bNtYqpdhYRc"
        },
        {
          name: "Github",
          url: "https://github.com/MohitMurotiya/CarServiceApplication"
        },
        
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/covid.png"),
      projectName: "Covid-19 Tracker",
      projectDesc: "It's a application to track number of cases and deaths of countries. Used 'Disease.sh' APIs to fetch the real-time data. Material-UI, Leaflet and Chart-JS2 libraries are used to for maps and charts and tables.",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://covid-19-9664a.web.app/"
        },
        {
          name: "Github",
          url: "https://github.com/MohitMurotiya/Covid-19-Tracker"
        }
      ]
    },
    {
      image: require("./assets/images/hbms.jfif"),
      projectName: "Hotel Bookings Management System",
      projectDesc: "Full stack end to end application in Angular 6 using spring framework and H2-Database. Netflix Eureka is used for load balancing and Hystrix is for fault tolerance.",
      footerLink: [
        {
          name: "Github",
          url: "https://github.com/MohitMurotiya/HotelBookingManagementSystem"
        }
      ]
    },
    {
      //image: require("./assets/images/hbms.jfif"),
      projectName: "Movie Application",
      projectDesc: "Web application to display category wise different movies and shows. Used 'TMDB' APIs for data. React-YouTube and movie-trailer libraries are used for fetching and playing YouTube trailers.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://pop-corn-time.netlify.app"
        },
        {
          name: "Github",
          url: "https://github.com/MohitMurotiya/Popcorn-Time"
        }
      ]
    },
    {
      //image: require("./assets/images/hbms.jfif"),
      projectName: "Foodler",
      projectDesc: "Made an App using Android Studio. Firebase is used for authentication and real time database. Multiple items can be ordered at the same time and notifications are managed using Firebase.",
      footerLink: []
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements & Certifications 🏆 "),
  subtitle: "",
  achievementsCards: [
    {
      title: "AWS Certified Developer",
      subtitle: "Got comprehensive understanding of application life-cycle management.",
      image: require("./assets/images/aws.png"),
      footerLink: [
        {
          name: "Certificate",
          url:
            "https://drive.google.com/file/d/1zBxlpNnUg8kc-ESdQZPreRDIS2M-Ns1y/view?usp=sharing"
        },
        {
          name: "See Credential",
          url:
            "https://www.youracclaim.com/badges/602c29ba-02d2-46f9-ba2b-9e339eda99d5/public_url"
        },
        {
          name: "Report",
          url:
            "https://drive.google.com/file/d/1D60Yc-WTeapoWC_tmV3Wu-nK35Z4mUhG/view?usp=sharing"
        }
      ]
    },

    {
      title: "AWS Fundamentals",
      subtitle: "Build Serverless Application using AWS Lambda, Amazon API Gateway, Amazon DynamoDB",
      image: require("./assets/images/coursera.png"),
      footerLink: [
        {name: "Certificate", url: "https://www.coursera.org/account/accomplishments/certificate/H6RLQMGZ7A4U"},
        {
          name: "See Credential",
          url: "https://www.coursera.org/account/accomplishments/verify/H6RLQMGZ7A4U"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: "Get In Touch",
  subtitle:
    emoji("Discuss a project or just want to say Hi🖐? My Inbox is open for all."),
  number: "+91-7742580241",
  email_address: "mohitmurotiya98@gmail.com",
  location: "Chittorgarh, Rajasthan"
};

// Twitter Section

const twitterDetails = {
  userName: "davidrakosi_", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  splashScreen,
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
